<script>
  import { textToId } from "$lib/utilities/dom-helpers";
  import Link from "$lib/components/Link.svelte";
  import Iframe from "./Iframe.svelte";

  let clazz = "";
  export { clazz as class };
  export let data;
  export let fullWidth = false;

  let url = data.fields.url;
  let title = data.fields.title;
  let description = data.fields?.description;
  // The iframe src attribute expects hardcoded hex value. Using the var(--color-cyan-700) does not override default color
  let playBtnColor = "#005e8a";
</script>

<div class="{clazz} {fullWidth} max-w-806 mx-auto" aria-label="SoundCloud clip {title}">
  <Iframe
    class="w-full h-[166px]"
    {title}
    id="soundcloud-{textToId(title)}"
    src="https://w.soundcloud.com/player/?url={url}&color={encodeURIComponent(
      playBtnColor
    )}&show_teaser=false"
  />
  <div class="mt-10 text-size-12">
    <Link {url} text={title} size="sm" iconClass="mt-4" class="!px-0" />
  </div>
  {#if description}
    <p class="mt-4">
      {description}
    </p>
  {/if}
</div>
